import useSWRMutation, { SWRMutationResponse } from "swr/mutation";
import { Contract } from "../../types";
// @ts-ignore
import useHttpClient from "../useHttpClient";
import { AxiosInstance } from "axios";

interface ContractPdfUrlResponse {
  url: string;
}

const useContractPdfUrl = (): SWRMutationResponse<ContractPdfUrlResponse, Error, string, string> => {
  const httpClient: AxiosInstance = useHttpClient();
  
  return useSWRMutation(
    "contract-pdf-url",
    async (_key, { arg: uuid }: { arg: string }): Promise<ContractPdfUrlResponse> => {
      const response = await httpClient.get(`/contracts/${uuid}/pdf-url`);
      return response.data.data;
    }
  );
};

export default useContractPdfUrl;

